import React, { useState } from 'react';
import { Route } from '~/Constants/Routes.constants';
import { useNavigation } from '~/Hooks';
import { FitoListReactQuery } from '~/Components';
import { IOrgStudioList } from '~/Models/interfaces/OrgStaff.model';
import { useRequestOrgStudioListWithStatus } from '~/Hooks/useOrgStudioList';
import { useOrgStudioList } from './useOrgStudioList';
import { useOrgStudioListDesktopTableDefinition } from './useOrgStudioListDesktopTableDefinition';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '~/UIKit/Style';
import { PrivateLayout } from '~/Layout/PrivateLayout';

export const useStudioPageStyles = makeStyles(() => ({
  fitListWrapper: {
    div: {
      minHeight: 'auto',
    },
  },
}));

export const StudioPage = () => {
  const PAGE_SIZE = 100;
  const { t } = useTranslation();
  const { classes } = useStudioPageStyles();
  const { navigate } = useNavigation();
  const [searchText, setSearchText] = useState('');

  const gotoStudioCreation = () => navigate(Route.ORGANISATION_STUDIO_CREATE);

  const { title, keyOfId, settings, setItemValues } = useOrgStudioList({ pageSize: PAGE_SIZE });
  const ProductListDesktopTableDefinition = useOrgStudioListDesktopTableDefinition();

  const queryForSearch = useRequestOrgStudioListWithStatus({ name: searchText });

  const pageTitle = {
    title,
    onAddButtonClick: gotoStudioCreation,
    actionName: t('app.add'),
  };

  const backendSearch = (txt: string) => {
    setSearchText(txt);
    return queryForSearch;
  };

  return (
    <PrivateLayout title={pageTitle} hideBackButton>
      <div className={classes.fitListWrapper}>
        <FitoListReactQuery<IOrgStudioList>
          keyOfId={keyOfId}
          settings={settings}
          title={title}
          setItemValues={setItemValues}
          tableDefinition={ProductListDesktopTableDefinition}
          pageSize={PAGE_SIZE}
          queryResults={useRequestOrgStudioListWithStatus}
          searchTextPlaceholder={t('app.search.studio')}
          backendSearch={backendSearch}
        />
      </div>
    </PrivateLayout>
  );
};
